import Box from "components/Box";

import SectionContent from "entities/Memo/components/Sections/SectionContent";
import SectionHeader from "entities/Memo/components/Sections/SectionHeader";
import { IMemoTemplateSection } from "entities/MemoTemplate/sdk";
import Table from "entities/TableStorage/components/Table";

interface IChecklistTable {
  section: IMemoTemplateSection;
}

const ChecklistTable = ({ section }: IChecklistTable) => (
  <Box sx={{ overflowX: "auto" }}>
    <SectionHeader label={section.title} />
    <SectionContent>
      <Box
        sx={{
          marginTop: "8px",
          "& .MuiIconButton-root": { visibility: "hidden" },
          "&:hover .MuiIconButton-root": {
            visibility: "visible",
          },
        }}
      >
        <Table
          sx={{ table: { width: "100%" } }}
          tableData={section.checklist_table.map((row) => ({
            cells: row.map(({ value }) => ({ value })),
          }))}
        />
      </Box>
    </SectionContent>
  </Box>
);

export default ChecklistTable;
